module.exports = __webpack_public_path__ + "img/motorcycle-red.2e46309d.svg";